export enum AtomKey {
    Language = 'language'
}
